import axios from "axios"

function subscribeToTrial({}, data) {
    return axios.post(`/api/v1/user/subscribe-trial`, data)
}

function getLiveRoomsAvailableForTrial({}, {}, params) {
    return axios.get(`/api/v2/live-rooms/available-for-trial`, { params })
}

function subscribeToTrialV2({}, data) {
    return axios.post(`/api/v2/user/subscribe-trial`, data)
}

function subscribeToSpecialV2({}, data) {
    return axios.post(`/api/v2/user/subscribe-special`, data)
}

function getSubscribePricing({}, {}, params) {
    return axios.get(`/api/v2/subscribe/pricing`, { params })
}

function getSubscribeRedirectUrl({}, {}, params) {
    return axios.get(`/api/v2/subscribe/redirect`, { params })
}

function submitTrialSlots({}, data) {
    return axios.post(`/api/v1/user/submit-trial-slots`, data)
}

function updatePrioritizedSchoolSubjects({}, data) {
    return axios.put(`/api/v2/subscribe/prioritized-school-subjects`, data)
}

function updateAvailabilitySlots({}, data) {
    return axios.put(`/api/v2/subscribe/availability-slots`, data)
}

function submitTutoringRequestUpdate({}, data) {
    return axios.post(`/api/v2/subscribe/tutoring-request-update`, data)
}

function checkPromoCode({}, data) {
    return axios.post(`/api/user/check-promo-code`, data)
}

function suspendSubscription({}, data) {
    return axios.post(`/api/v1/subscription/pause-resume-choice`, data)
}

function getPauseResumeChoice({}, {}, params) {
    return axios.get(`/api/v1/subscription/pause-resume-choice`, { params })
}

function callMeBack({}, data) {
    return axios.post(`/api/v2/trial-call-me-back`, data)
}

function formulateObjective({}, data) {
    return axios.post(`/api/v2/subscribe/objectives/formulate`, data)
}

function updateSubscriptionPossibleSlots({}, data) {
    return axios.post(`/api/subscription/update-possible-slots`, data)
}

function selfCreateSubscription({}, data) {
    return axios.post(`/api/subscription/self-create-subscription`, data)
}

function adminCreateSubscription({}, data) {
    return axios.post(`/api/subscription/admin-create-subscription`, data)
}

// « Utiliser ma carte » sur la page du lien : réserve la vente sur la carte
// enregistrée (1 € nouveau client, vérification à 0 € sinon), puis confirme
// après une éventuelle validation 3-D Secure.
function reserveWithSavedCard({}, data) {
    return axios.post(
        `/api/subscription/admin-create-subscription/saved-card`,
        data
    )
}

// Repli du lien de vente quand le navigateur empêche notre page de monter le
// formulaire de paiement : la même vente, sur la page de Stripe (`url`).
function adminCreateHostedCheckoutSession({}, data) {
    return axios.post(
        `/api/subscription/admin-create-subscription/hosted`,
        data
    )
}

function confirmSavedCardReservation({}, data) {
    return axios.post(
        `/api/subscription/admin-create-subscription/saved-card/confirm`,
        data
    )
}

function getLastReport({}, {}, params) {
    return axios.get(`/api/v2/subscribe/last-report`, { params })
}

function logParentModeAction({}, data, params) {
    return axios.post(`/api/v2/subscribe/log-parent-mode-action`, data, {
        params,
    })
}

function getMyOpenInvoices({}, {}, params) {
    return axios.get(`/api/v2/subscribe/open-invoices`, { params })
}

function getInvoicePaymentUrl({ invoiceId }, {}, params) {
    return axios.post(
        `/api/v2/subscribe/invoices/${invoiceId}/payment-url`,
        {},
        { params }
    )
}

function getStageCheckoutSession({}, data) {
    return axios.post(`/api/subscription/stage-checkout-session`, data)
}

function getParentPauseBalance() {
    return axios.get(`/api/v1/subscription/pause/balance`)
}

function pauseSubscriptionParent({}, data) {
    return axios.post(`/api/v1/subscription/pause`, data)
}

function cancelParentPause({}, data) {
    return axios.post(`/api/v1/subscription/pause/cancel`, data ?? {})
}

function createExtraHourRequest({}, data) {
    return axios.post(`/api/v1/extra-hour-requests`, data)
}

// Pose le choix d'été du parent (3 dimensions : juneTransition,
// summerStatus, resumePreference) sur le student courant. Le backend
// upsert sur (user_id, year) et retourne le UserResource refreshed.
function confirmSummerChoice({}, data) {
    return axios.post(`/api/v1/subscription/summer-choice`, data)
}

// Active la "suite" self-service (produit d'appel → offre régulière). Planifie
// un jalon à la date de reprise côté back et renvoie le UserResource refreshed
// (avec `upcoming_activation.planned` renseigné). Body optionnel : { offer_type,
// hours_per_week, with_commitment } — sinon l'offre recommandée est utilisée.
function activateSubscriptionSuite({}, data) {
    return axios.post(`/api/v1/subscription/activation`, data ?? {})
}

// Entrée par LIEN de l'activation (CTA d'un mail / SMS). Mêmes règles que
// ci-dessus, autre porte : le parent n'est pas connecté, c'est la signature
// portée par `params` qui l'identifie. Deux appels distincts du chemin in-app
// pour que la landing ait son propre état de chargement et d'erreur.
function getActivationLinkContext({}, {}, params) {
    return axios.get(`/api/v1/activation-link/context`, { params })
}

function activateSubscriptionSuiteFromLink({}, data, params) {
    return axios.post(`/api/v1/activation-link/activate`, data ?? {}, {
        params,
    })
}

// Créneaux de la reprise, choisis depuis la carte « Reprise planifiée ».
// Body : { slots: ["Monday 17h-18h", …] } — la grammaire de la grille
// ConstraintsGridStep. Écrit la disponibilité standing (`slots_possible`),
// trace les créneaux sur le jalon et fait suivre la demande de rentrée.

// Balise de LECTURE : « la famille a ouvert sa reprise ». Sans corps, réponse
// 204 — elle date la PREMIÈRE consultation côté back (les suivantes sont des
// no-op) et c'est ce signal qui éteint les rappels J-5 / J-3. Postée depuis la
// carte de reprise du portail : la landing du lien magique ne peut pas la
// porter, ses GET étant préchargés par les scanners de mail.
function markActivationViewed() {
    return axios.post(`/api/v1/subscription/activation/viewed`)
}

// Même balise, porte du LIEN SIGNÉ : le parent n'est pas connecté, c'est la
// signature qui l'identifie. POST (jamais GET) — c'est ce qui la distingue d'un
// préchargement par un scanner de mail.
function markActivationViewedFromLink({}, {}, params) {
    return axios.post(`/api/v1/activation-link/viewed`, {}, { params })
}

// Prolonge les cours d'été jusqu'à la fin de l'édition (31 août) pour combler le
// trou fin de produit → reprise. Sans body : la cible est canonique côté back.
// Renvoie le UserResource refreshed (`upcoming_activation.due_date` déplacée, le
// bloc « trou de couverture » se recalcule ou disparaît). 409 si déjà prolongé.
function extendSummerSubscription() {
    return axios.post(`/api/v1/subscription/extend-summer`, {})
}

// Session Stripe Billing Portal créée AU CLIC : l'URL renvoyée est éphémère
// (une session générée au chargement de page meurt avant le clic), et le
// deep-link moyens de paiement passe par flow_data — jamais par un suffixe
// d'URL, qui corrompt le `?secret=` de la session.
function createBillingPortalSession({}, data) {
    return axios.post(`/api/v1/billing-portal-session`, data)
}

// Preview des frais de résiliation pour l'écran "Frais" du parcours churn.
// Read-only — wrappe CancellationFeesService côté back pour garder le
// montant affiché single-source-of-truth avec le montant facturé au POST.
function getCancellationFees() {
    return axios.get(`/api/v1/subscription/cancellation-fees`)
}

// Soumet l'intent de résiliation (motif + outcome). Pour outcome=cancelled,
// déclenche aussi le prélèvement des frais via Cashier et planifie le
// `subscription->cancel()` Stripe. Le back renvoie 200 + UserResource
// refreshed (avec `subscription_state.end_date` pointant sur la fin
// d'accès), 402 si paiement échoué, 422 si pas de sub active.
function cancelSubscription({}, data) {
    return axios.post(`/api/v1/subscription/cancel`, data)
}

export const subscriptionService = {
    createBillingPortalSession,
    getStageCheckoutSession,
    subscribeToTrial,
    subscribeToTrialV2,
    subscribeToSpecialV2,
    submitTrialSlots,
    checkPromoCode,
    suspendSubscription,
    getPauseResumeChoice,
    getLiveRoomsAvailableForTrial,
    getSubscribeRedirectUrl,
    getSubscribePricing,
    callMeBack,
    updatePrioritizedSchoolSubjects,
    updateAvailabilitySlots,
    submitTutoringRequestUpdate,
    formulateObjective,
    updateSubscriptionPossibleSlots,
    selfCreateSubscription,
    getLastReport,
    logParentModeAction,
    getMyOpenInvoices,
    getInvoicePaymentUrl,
    adminCreateSubscription,
    reserveWithSavedCard,
    adminCreateHostedCheckoutSession,
    confirmSavedCardReservation,
    getParentPauseBalance,
    pauseSubscriptionParent,
    cancelParentPause,
    createExtraHourRequest,
    confirmSummerChoice,
    activateSubscriptionSuite,
    getActivationLinkContext,
    activateSubscriptionSuiteFromLink,
    markActivationViewed,
    markActivationViewedFromLink,
    extendSummerSubscription,
    getCancellationFees,
    cancelSubscription,
}
